import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADMIN_PAGES_KEYS, NS } from '../../../i18n/constants/keys';
import LoadingSpinner from '../../job_openings/create/ui/LoaderSpinner';
import { Tabs } from '../../assessment/view/tabs/tabs';
import { FrameworkStatsHeader } from './components';
import {
  JobTitleManagementContainer,
  SkillsManagementContainer,
} from './containers';
import { useAssessmentFramework } from './hooks';

export * from './components';
export * from './constants';
export * from './containers';
export * from './functions';
export * from './hooks';
export * from './interfaces';

export const AssessmentFramework = () => {
  const { t } = useTranslation(NS.adminPages);
  const {
    activeTab,
    setActiveTab,
    isLoading,
    skillsList,
    subSkillList,
    jobTitles,
  } = useAssessmentFramework();

  const tabTitles = [
    t(ADMIN_PAGES_KEYS.assessmentFramework.tabs.skills),
    t(ADMIN_PAGES_KEYS.assessmentFramework.tabs.jobTitles),
  ];

  const renderTabContent = () => {
    if (isLoading) {
      return (
        <div className='flex flex-col justify-center items-center min-h-[350px] gap-3 bg-white rounded-xl border border-gray-100 p-8 shadow-sm my-4'>
          <LoadingSpinner label='' />
          <p className='text-xs font-semibold text-slate-400 tracking-wide uppercase'>
            {activeTab === 0
              ? 'Loading Skills & Sub-Skills...'
              : 'Loading Job Titles...'}
          </p>
        </div>
      );
    }

    if (activeTab === 0) {
      return (
        <SkillsManagementContainer
            skills={skillsList}
            subSkillList={subSkillList}
        />
      );
    } else if (activeTab === 1) {
      return <JobTitleManagementContainer jobTitles={jobTitles} />;
    }
  };

  return (
    <div className='w-full h-full flex flex-col gap-5'>
      <FrameworkStatsHeader
          skillsCount={skillsList.length}
          subSkillsCount={subSkillList.length}
          jobTitlesCount={jobTitles.length}
      />

      <div className='w-full'>
        <Tabs
            tabTitles={tabTitles}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        />
        {renderTabContent()}
      </div>
    </div>
  );
};
